import { Loading } from "../../../common/components/Loading/Loading";
import { useZerezesClubAccount } from "../../../providers/ZerezesClubAccountProvider";
import { CurrentPageActionType } from "../ZClubAccountPageCommon";
import { ZClubAccountPageBodyExchangePoints } from "./ZClubAccountPageBodyExchangePoints";
import { ZClubAccountPageBodyMemberAccount } from "./ZClubAccountPageBodyMemberAccount";
import { ZClubAccountPageBodySearch } from "./ZClubAccountPageBodySearch";

export const ZClubAccountPageBody = () => {

  const {
    currentPageAction,
    loading
  } = useZerezesClubAccount();

  if (loading) return <Loading />

  switch (currentPageAction) {
    case CurrentPageActionType.ExchangePoints:
      return <ZClubAccountPageBodyExchangePoints />;
    case CurrentPageActionType.Search:
      return <ZClubAccountPageBodySearch />;
    case CurrentPageActionType.Account:
      return <ZClubAccountPageBodyMemberAccount />;
    default:
      return null;
  }
}